import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import type { FC } from 'react';

interface IProps {
  baseline?: number | null;
  total?: number | null;
  heights?: {
    baseline?: string;
    total?: string;
  };
  classNames?: {
    baseline?: string;
    total?: string;
    parent?: string;
  } | null;
  withMarkers?: boolean;
  withOverageMarker?: boolean;
}

const PairedProgressBar: FC<IProps> = ({
  baseline,
  total,
  heights,
  classNames,
  withMarkers = false,
}) => {
  const safeBaseline = baseline ?? 0;
  const safeTotal = total ?? 0;
  const baselineWidth = safeTotal === 0 ? 0 : (safeBaseline * 100) / safeTotal;
  const isOverBaseline = safeBaseline > safeTotal;
  const totalWidth =
    safeTotal === 0 ? 100 : ((safeTotal - safeBaseline) * 100) / safeTotal;

  return (
    <div className="relative">
      <div
        className={clsx(
          'flex items-center gap-1 w-full relative z-10',
          classNames?.parent,
        )}
      >
        <div
          style={{
            width: `${baselineWidth}%`,
          }}
          className={clsx(
            'rounded transition-all duration-300',
            heights?.baseline ?? 'h-1.5',
            classNames?.baseline,
          )}
        />
        <div
          style={{
            width: `${totalWidth}%`,
          }}
          className={clsx(
            'rounded transition-all duration-300',
            heights?.total ?? 'h-1',
            classNames?.total,
          )}
        />
      </div>
      {withMarkers && (
        <div className="relative -mt-[6px] w-full z-0">
          <div
            className="absolute w-[1px] h-2 bg-juno-gray-700"
            style={{ left: '25%' }}
          />
          <div
            className="absolute w-[1px] h-3 -mt-[2px] bg-juno-gray-700"
            style={{ left: '50%' }}
          />
          <div
            className="absolute w-[1px] h-2 bg-juno-gray-700"
            style={{ left: '75%' }}
          />
        </div>
      )}
      {isOverBaseline && (
        <div className="absolute -right-1 -top-3.5">
          <FontAwesomeIcon icon={faPlus} className="fa-fw text-xs scale-75" />
        </div>
      )}
    </div>
  );
};

export default PairedProgressBar;
